import { type CSSProperties } from 'react';
import { classNames } from '@vkontakte/vkui';
import styles from './AppearanceImage.module.css';

interface AppearanceImageProps {
  light: string;

  className?: string;
  dark?: string;
  aspectRatio?: number | string;
}

export function AppearanceImage(props: AppearanceImageProps) {
  const { className, light, dark, aspectRatio } = props;
  return (
    <picture role="presentation">
      <source srcSet={light} media="(prefers-color-scheme: light)" />
      {dark && <source srcSet={dark} media="(prefers-color-scheme: dark)" />}
      <img
        className={classNames(styles.inner, className)}
        style={
          aspectRatio !== undefined ? ({ '--internal--aspect-ratio': String(aspectRatio) } as CSSProperties) : undefined
        }
        src={light}
        alt=""
      />
    </picture>
  );
}
